export const th = {
  // 네비게이션
  nav_home: "หน้าแรก",
  nav_growth: "บันทึกการเติบโต",
  nav_statistics: "สถิติ",
  nav_family: "ตั้งค่าครอบครัว",
  nav_backup: "สำรองข้อมูล",
  nav_add_memory: "เพิ่มความทรงจำ",
  nav_main_menu: "เมนูหลัก",
  nav_photobook: "สร้างโฟโต้บุค",
  nav_family_settings: "ตั้งค่าครอบครัว",
  nav_share: "แชร์",
  nav_memories: "ดูความทรงจำ",
  nav_albums: "อัลบั้ม",
  nav_invite: "เชิญครอบครัว",
  nav_admin: "ผู้ดูแลระบบ",
  nav_activity_log: "บันทึกกิจกรรม",
  nav_trash: "ถังขยะ",
  nav_profile: "โปรไฟล์",
  nav_login: "เข้าสู่ระบบ",
  nav_logout: "ออกจากระบบ",
  
  // 사이트 공통
  site_title: "มินโฮมินอา",
  language: "ภาษา",
  
  // 인증
  auth_login: "เข้าสู่ระบบ",
  auth_logout: "ออกจากระบบ",
  auth_signup: "สมัครสมาชิก",
  auth_account: "บัญชี",
  
  // หน้าเข้าสู่ระบบ
  login: {
    title: "เข้าสู่ระบบ",
    signupTitle: "สมัครสมาชิก",
    subtitle: "แบ่งปันความทรงจำอันล้ำค่าของมินโฮและมินอา",
    name: "ชื่อ",
    namePlaceholder: "สมชาย ใจดี",
    email: "อีเมล",
    emailPlaceholder: "your@email.com",
    password: "รหัสผ่าน",
    passwordPlaceholder: "••••••••",
    confirmPassword: "ยืนยันรหัสผ่าน",
    passwordMismatch: "รหัสผ่านไม่ตรงกัน",
    passwordTooShort: "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
    signupSuccess: "สมัครสมาชิกสำเร็จ! กรุณาตรวจสอบอีเมลของคุณ",
    emailAlreadyExists: "อีเมลนี้ลงทะเบียนแล้ว",
    signupError: "เกิดข้อผิดพลาดระหว่างการสมัครสมาชิก",
    loginError: "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
    signingUp: "กำลังสมัครสมาชิก...",
    loggingIn: "กำลังเข้าสู่ระบบ...",
    haveAccount: "มีบัญชีอยู่แล้ว?",
    noAccount: "ยังไม่มีบัญชี?",
    loginButton: "เข้าสู่ระบบ",
    signupButton: "สมัครสมาชิก"
  },
  
  // 히어로 섹션
  hero_title: "มินโฮและมินอา",
  hero_subtitle: "ช่วงเวลาที่มีค่า",
  hero_description: "พื้นที่สำหรับบันทึกเรื่องราวการเติบโตของลูกๆ เก็บความทรงจำ และแบ่งปันความรัก",
  
  // 통계 카드
  stat_total_posts: "โพสต์ทั้งหมด",
  stat_photos: "รูปภาพ",
  stat_videos: "วิดีโอ",
  stat_milestones: "วันสำคัญ",
  
  // 필터 섹션
  filter_title: "กรองความทรงจำ",
  filter_search_placeholder: "ค้นหาด้วยชื่อหรือคำอธิบาย...",
  filter_age_view: "ดูตามอายุ",
  filter_all: "ทั้งหมด",
  filter_tags: "กรองแท็ก",
  filter_reset: "รีเซ็ต",
  filter_slideshow: "สไลด์โชว์",
  filter_photobook: "สร้างอัลบั้มรูป",
  filter_all_people: "ดูทั้งหมด",
  filter_minho: "มินโฮ",
  filter_mina: "มินอา",
  filter_both: "มินโฮมินอา",
  
  // 레이아웃
  layout_grid: "กริด",
  layout_masonry: "แบบก่ออิฐ",
  layout_timeline: "ไทม์ไลน์",
  
  // 공통 메시지
  msg_loading: "กำลังโหลด...",
  msg_no_data: "ไม่มีข้อมูล",
  msg_error: "เกิดข้อผิดพลาด",
  msg_success: "ดำเนินการเสร็จสิ้น",
  no_memories: "ไม่มีความทรงจำ",
  
  // 버튼
  btn_save: "บันทึก",
  btn_cancel: "ยกเลิก",
  btn_edit: "แก้ไข",
  btn_delete: "ลบ",
  btn_share: "แชร์",
  btn_close: "ปิด",
  
  // 백업 페이지
  backup_title: "สำรองข้อมูลและส่งออก",
  backup_subtitle: "เก็บรักษาความทรงจำอันล้ำค่าของคุณอย่างปลอดภัยและกู้คืนได้ทุกเมื่อ",
  backup_full: "สำรองข้อมูลทั้งหมด",
  backup_full_desc: "สำรองข้อมูลทั้งหมดในครั้งเดียว",
  backup_full_download: "ดาวน์โหลดการสำรองข้อมูลทั้งหมด",
  backup_memories: "สำรองความทรงจำ",
  backup_memories_desc: "สำรองเฉพาะรูปภาพและข้อมูลความทรงจำ",
  backup_memories_download: "ดาวน์โหลดการสำรองความทรงจำ",
  backup_settings: "สำรองการตั้งค่า",
  backup_settings_desc: "สำรองเฉพาะการตั้งค่าครอบครัวและแท็ก",
  backup_settings_download: "ดาวน์โหลดการสำรองการตั้งค่า",
  backup_restore: "กู้คืนข้อมูลสำรอง",
  backup_restore_desc: "ลากหรือคลิกเพื่อเลือกไฟล์สำรองข้อมูล",
  backup_restore_formats: "รูปแบบที่รองรับ: JSON, ZIP",
  backup_restore_btn: "กู้คืนข้อมูลสำรอง",
  backup_auto: "ตั้งค่าการสำรองอัตโนมัติ",
  backup_auto_enable: "เปิดใช้งานการสำรองอัตโนมัติ",
  backup_frequency: "ความถี่ในการสำรอง",
  backup_daily: "ทุกวัน",
  backup_weekly: "ทุกสัปดาห์",
  backup_monthly: "ทุกเดือน",
  backup_time: "เวลาสำรอง",
  backup_max_count: "จำนวนการสำรองสูงสุด",
  backup_save_settings: "บันทึกการตั้งค่า",
  backup_history: "ประวัติการสำรอง",
  
  // 홈페이지
  hero_our_children: "ลูกๆ ของเรา",
  hero_view_memories: "ดูความทรงจำ",
  hero_add_memory: "เพิ่มความทรงจำ",
  stat_total_memories: "ความทรงจำทั้งหมด",
  section_our_children: "ลูกๆ ของเรา",
  child_minho_title: "มินโฮ",
  child_minho_desc: "ลูกคนโตที่น่าเชื่อถือ เรื่องราวการเติบโตของมินโฮ",
  child_minho_view: "ดูความทรงจำของมินโฮ",
  child_mina_title: "มินอา",
  child_mina_desc: "ลูกคนเล็กที่น่ารัก ชีวิตประจำวันที่น่ารักของมินอา",
  child_mina_view: "ดูความทรงจำของมินอา",
  section_recent_memories: "ความทรงจำล่าสุด",
  view_all_memories: "ดูความทรงจำทั้งหมด",
  cta_title: "บันทึกช่วงเวลาล้ำค่าของวันนี้",
  cta_desc: "เก็บความทรงจำที่ส่องแสงผ่านกาลเวลาไว้ที่ MinhoMinah.com",
  btn_upload_memory: "อัพโหลดความทรงจำ",
  btn_start: "เริ่มต้น",
  
  // 업로드 페이지
  upload_title: "เพิ่มความทรงจำใหม่",
  upload_edit_title: "แก้ไขความทรงจำ",
  upload_subtitle: "บันทึกช่วงเวลาล้ำค่าตลอดไป",
  upload_edit_subtitle: "แก้ไขช่วงเวลาล้ำค่าของคุณ",
  upload_media_label: "รูปภาพ/วิดีโอ *",
  upload_drag_drop: "ลากไฟล์มาที่นี่หรือ",
  upload_select_file: "เลือกไฟล์",
  upload_file_types: "JPG, PNG, GIF, MP4, MOV (สูงสุด 50MB)",
  upload_existing_files: "ไฟล์ที่มีอยู่",
  upload_title_label: "ชื่อเรื่อง *",
  upload_title_placeholder: "ใส่ชื่อความทรงจำ",
  upload_title_required: "กรุณาใส่ชื่อเรื่อง",
  upload_description_label: "คำอธิบาย",
  upload_description_placeholder: "ใส่คำอธิบายความทรงจำ",
  upload_date_label: "วันที่ *",
  upload_date_required: "กรุณาเลือกวันที่",
  upload_people_label: "คนที่อยู่ด้วยกัน",
  upload_add_person: "เพิ่มบุคคล",
  upload_tags_label: "แท็ก",
  upload_add_tag: "เพิ่มแท็ก",
  upload_album_label: "อัลบั้ม",
  upload_submit: "เพิ่มความทรงจำ",
  upload_edit_submit: "อัพเดทความทรงจำ",
  upload_uploading: "กำลังอัพโหลด...",
  upload_editing: "กำลังอัพเดท...",
  upload_min_one_file: "กรุณาเพิ่มรูปภาพหรือวิดีโออย่างน้อยหนึ่งไฟล์",
  upload_min_one_media: "ต้องเก็บรูปภาพหรือวิดีโออย่างน้อยหนึ่งไฟล์",
  upload_login_required: "ต้องเข้าสู่ระบบ",
  upload_error: "เกิดข้อผิดพลาดระหว่างอัพโหลด",
  upload_edit_error: "เกิดข้อผิดพลาดระหว่างอัพเดท",
  
  // แกลเลอรี่ความทรงจำ
  memories: {
    title: "แกลเลอรี่ความทรงจำ",
    error: "เกิดข้อผิดพลาดในการโหลดความทรงจำ",
    refresh: "รีเฟรช",
    searchPlaceholder: "ค้นหาความทรงจำ...",
    count: " ความทรงจำ",
    ageFilter: "ดูตามอายุ",
    all: "ทั้งหมด",
    age: " ปี",
    filter: "ตัวกรอง",
    personFilter: "บุคคล",
    yearFilter: "ปี",
    year: "",
    tagFilter: "แท็ก",
    filterReset: "รีเซ็ตตัวกรอง",
    photos: " รูปภาพ",
    noResults: "ไม่มีผลการค้นหา",
    noMemories: "ยังไม่มีความทรงจำ",
    loadingMore: "กำลังโหลดความทรงจำเพิ่มเติม...",
    allLoaded: "โหลดความทรงจำทั้งหมดแล้ว",
    deleteConfirmTitle: "ลบความทรงจำนี้หรือไม่?",
    deleteConfirmMessage: "จะถูกลบและไม่สามารถกู้คืนได้",
    cancel: "ยกเลิก",
    deleting: "กำลังลบ...",
    edit: "แก้ไข",
    delete: "ลบ",
    deleteError: "ไม่สามารถลบความทรงจำได้",
    permissionError: "คุณไม่มีสิทธิ์ในการลบ กรุณาติดต่อผู้ดูแลระบบ",
    slideshow: "สไลด์โชว์",
    share: "แชร์",
    download: "ดาวน์โหลด",
    comments: "ความคิดเห็น",
    backToGallery: "กลับไปที่แกลเลอรี่ความทรงจำ",
    notFound: "ไม่พบความทรงจำ",
    notFoundDescription: "ความทรงจำที่คุณร้องขอไม่มีอยู่หรือถูกลบไปแล้ว",
    loadError: "เกิดข้อผิดพลาดขณะโหลดความทรงจำ",
    addToAlbum: "เพิ่มไปยังอัลบั้ม",
    selectAlbums: "เลือกอัลบั้ม",
    updateError: "ไม่สามารถอัปเดตความทรงจำได้"
  },
  
  // 성장 기록 페이지
  growth: {
    title: "บันทึกการเติบโต",
    subtitle: "ติดตามการเติบโตของมินโฮและมินอาด้วยกราฟ",
    addRecord: "เพิ่มบันทึก",
    currentStatus: "สถานะปัจจุบัน",
    recentGrowth: "การเติบโตล่าสุด",
    last3Months: "3 เดือนล่าสุด",
    lastRecord: "บันทึกล่าสุด",
    height: "ส่วนสูง",
    weight: "น้ำหนัก",
    heightCm: "ส่วนสูง (ซม.)",
    weightKg: "น้ำหนัก (กก.)",
    growthChart: "กราฟการเติบโต",
    recordHistory: "ประวัติบันทึกการเติบโต",
    date: "วันที่",
    age: "อายุ",
    memo: "บันทึก",
    actions: "การดำเนินการ",
    noRecords: "ยังไม่มีบันทึกการเติบโต",
    addRecordTitle: "เพิ่มบันทึกการเติบโต",
    person: "บุคคล",
    selectPerson: "เลือก",
    memoOptional: "บันทึก (ไม่จำเป็น)",
    save: "บันทึก",
    saving: "กำลังบันทึก...",
    cancel: "ยกเลิก",
    recordAdded: "เพิ่มบันทึกการเติบโตแล้ว!",
    recordDeleted: "ลบบันทึกแล้ว",
    deleteConfirm: "ลบบันทึกนี้หรือไม่?",
    noAgeInfo: "ไม่มีข้อมูลอายุ",
    years: " ปี",
    months: " เดือน",
    daysAgo: " วันที่แล้ว"
  },
  
  // 통계 페이지
  statistics: {
    title: "แดชบอร์ดสถิติ",
    totalMemories: "ความทรงจำทั้งหมด",
    photos: "รูปภาพ",
    videos: "วิดีโอ",
    mostActiveMonth: "เดือนที่มีกิจกรรมมากที่สุด",
    monthlyStats: "สถิติความทรงจำรายเดือน",
    personStats: "สถิติตามบุคคล",
    tagCloud: "คลาวด์แท็ก",
    memoryCount: "จำนวนความทรงจำ",
    noData: "ยังไม่มีข้อมูล",
    noTags: "ยังไม่มีแท็ก",
    noneYet: "ยังไม่มี"
  },
  
  // 앨범 페이지
  albums: {
    title: "อัลบั้ม",
    newAlbum: "อัลบั้มใหม่",
    noAlbums: "ยังไม่มีอัลบั้ม",
    createFirst: "สร้างอัลบั้มแรกของคุณ!",
    memoriesCount: " ความทรงจำ",
    createAlbum: "สร้างอัลบั้ม",
    albumName: "ชื่ออัลบั้ม",
    albumNamePlaceholder: "เช่น ทริปครอบครัว 2024",
    description: "คำอธิบาย",
    descriptionPlaceholder: "ใส่คำอธิบายสำหรับอัลบั้มนี้",
    makePublic: "ตั้งเป็นอัลบั้มสาธารณะ",
    create: "สร้าง",
    creating: "กำลังสร้าง...",
    cancel: "ยกเลิก",
    backToAlbums: "กลับไปที่อัลบั้ม",
    notFound: "ไม่พบอัลบั้ม",
    noMemories: "ไม่มีความทรงจำในอัลบั้มนี้",
    addMemoriesDesc: "คุณสามารถเพิ่มความทรงจำจากแกลเลอรีความทรงจำ",
    addMemories: "เพิ่มความทรงจำ",
    editAlbum: "แก้ไขอัลบั้ม",
    save: "บันทึก",
    saving: "กำลังบันทึก...",
    deleteAlbum: "ลบอัลบั้ม",
    deleteConfirm: "คุณแน่ใจหรือไม่ที่จะลบอัลบั้มนี้? ความทรงจำในอัลบั้มจะไม่ถูกลบ",
    delete: "ลบ",
    deleting: "กำลังลบ...",
    updateError: "ไม่สามารถอัปเดตอัลบั้มได้",
    setCover: "ตั้งเป็นปกอัลบั้ม"
  },
  
  // 포토북 만들기 페이지
  photobook: {
    title: "สร้างโฟโต้บุ๊ค",
    subtitle: "เปลี่ยนความทรงจำอันล้ำค่าของคุณให้เป็นโฟโต้บุ๊คที่สวยงาม",
    settings: "การตั้งค่าโฟโต้บุ๊ค",
    template_selection: "เลือกเทมเพลต",
    template_classic: "คลาสสิค",
    template_classic_desc: "ดีไซน์หรูหราและดั้งเดิม",
    template_modern: "โมเดิร์น",
    template_modern_desc: "เลย์เอาต์ทันสมัยและมีสไตล์",
    template_minimal: "มินิมอล",
    template_minimal_desc: "สไตล์สะอาดและเรียบง่าย",
    period_to_include: "ช่วงเวลาที่จะรวม",
    start_date: "วันที่เริ่มต้น",
    end_date: "วันที่สิ้นสุด",
    options: "ตัวเลือก",
    include_cover_page: "รวมหน้าปก",
    include_stats_page: "รวมหน้าสถิติ",
    include_index_page: "รวมหน้าสารบัญ",
    include_timeline: "รวมไทม์ไลน์",
    people_to_include: "บุคคลที่จะรวม",
    all: "ทั้งหมด",
    minho_only: "มินโฮเท่านั้น",
    mina_only: "มินอาเท่านั้น",
    minho_mina_together: "มินโฮและมินอาด้วยกัน",
    preview: "ดูตัวอย่าง",
    generate_photobook: "สร้างโฟโต้บุ๊ค",
    photobook_preview: "ตัวอย่างโฟโต้บุ๊ค",
    creating_photobook: "กำลังสร้างโฟโต้บุ๊ค...",
    preparing: "กำลังเตรียมรูปภาพ..."
  },
  
  // 활동 로그 페이지
  activityLog: {
    title: "บันทึกกิจกรรม",
    export: "ส่งออก",
    allActivities: "กิจกรรมทั้งหมด",
    create: "สร้าง",
    update: "อัพเดท",
    delete: "ลบ",
    share: "แชร์",
    noActivities: "ไม่มีบันทึกกิจกรรม",
    noActivitiesDesc: "กิจกรรมจะถูกบันทึกที่นี่เมื่อคุณเพิ่มหรือแก้ไขความทรงจำ",
    action_create: "เพิ่มความทรงจำใหม่",
    action_update: "อัพเดทความทรงจำ",
    action_delete: "ลบความทรงจำ",
    action_restore: "กู้คืนความทรงจำ",
    action_share: "แชร์ความทรงจำ",
    action_download: "ดาวน์โหลดความทรงจำ"
  },
  
  // 휴지통 페이지
  trash: {
    title: "ถังขยะ",
    auto_delete_notice: "รายการในถังขยะจะถูกลบถาวรหลังจาก 30 วัน",
    select_all: "เลือกทั้งหมด",
    deselect_all: "ยกเลิกการเลือก",
    selected_count: " รายการที่เลือก",
    restore: "กู้คืน",
    delete_permanently: "ลบถาวร",
    empty_title: "ถังขยะว่างเปล่า",
    empty_desc: "รายการที่ถูกลบจะแสดงที่นี่",
    deleted_date: "ลบเมื่อ",
    permanent_delete_days: " วันก่อนลบถาวร",
    confirm_permanent_delete: "คุณแน่ใจหรือไม่ว่าต้องการลบรายการที่เลือกอย่างถาวร? การดำเนินการนี้ไม่สามารถย้อนกลับได้"
  },
  
  // Profile Page
  profile: {
    title: "โปรไฟล์ของฉัน",
    loading_error: "เกิดข้อผิดพลาดในการโหลดโปรไฟล์",
    not_found: "ไม่พบโปรไฟล์",
    update_success: "อัพเดทโปรไฟล์เรียบร้อยแล้ว",
    update_error: "เกิดข้อผิดพลาดในการอัพเดทโปรไฟล์",
    basic_info: "ข้อมูลพื้นฐาน",
    email: "อีเมล",
    username: "ชื่อผู้ใช้",
    username_placeholder: "กรอกชื่อผู้ใช้",
    full_name: "ชื่อเต็ม",
    full_name_placeholder: "กรอกชื่อเต็ม",
    not_set: "ยังไม่ได้ตั้งค่า",
    role: "บทบาท",
    role_parent: "ผู้ปกครอง",
    role_family: "ครอบครัว",
    role_viewer: "ผู้เยี่ยมชม",
    role_parent_desc: "สามารถเข้าถึงฟีเจอร์ทั้งหมด",
    role_family_desc: "สามารถดูความทรงจำและเพิ่มความคิดเห็น",
    role_viewer_desc: "สามารถดูความทรงจำเท่านั้น",
    cancel: "ยกเลิก",
    save: "บันทึก",
    saving: "กำลังบันทึก...",
    account_info: "ข้อมูลบัญชี",
    joined_date: "เข้าร่วมเมื่อ",
    last_updated: "แก้ไขล่าสุด"
  },

  // หน้าผู้ดูแลระบบ
  admin: {
    title: "หน้าผู้ดูแลระบบ",
    subtitle: "จัดการผู้ใช้และตรวจสอบกิจกรรมของระบบ",
    accessDenied: "ไม่มีสิทธิ์เข้าถึง",
    accessDeniedDesc: "หน้านี้สำหรับผู้ดูแลระบบ (parent) เท่านั้น",
    userManagement: "จัดการผู้ใช้",
    activityLog: "บันทึกกิจกรรม",
    loading: "กำลังโหลด...",
    user: "ผู้ใช้",
    email: "อีเมล",
    role: "บทบาท",
    joinedDate: "เข้าร่วมเมื่อ",
    actions: "การดำเนินการ",
    edit: "แก้ไข",
    roleBadge: {
      parent: "ผู้ดูแลระบบ",
      family: "ครอบครัว",
      viewer: "ทั่วไป"
    },
    updateRole: "เปลี่ยนบทบาท",
    updating: "กำลังเปลี่ยน...",
    roleUpdated: "อัปเดตบทบาทผู้ใช้แล้ว",
    roleUpdateFailed: "อัปเดตบทบาทล้มเหลว",
    profileModal: {
      title: "แก้ไขโปรไฟล์",
      email: "อีเมล",
      username: "ชื่อผู้ใช้",
      fullName: "ชื่อเต็ม",
      save: "บันทึก",
      cancel: "ยกเลิก",
      saving: "กำลังบันทึก...",
      updated: "อัปเดตโปรไฟล์แล้ว",
      updateFailed: "อัปเดตโปรไฟล์ล้มเหลว"
    },
    activity: {
      action: "การดำเนินการ",
      created: "สร้าง",
      updated: "แก้ไข",
      deleted: "ลบ",
      details: "รายละเอียด",
      date: "วันที่",
      noData: "ไม่มีบันทึกกิจกรรม"
    },
    unknown: "ไม่ทราบ",
    notSet: "ไม่ได้ตั้งค่า",
    ago: "ที่แล้ว",
    tagManagement: "จัดการแท็ก",
    peopleManagement: "จัดการบุคคล",
    tags: {
      name: "ชื่อแท็ก",
      usageCount: "จำนวนที่ใช้",
      memories: " ความทรงจำ",
      deleted: "ลบแท็กเรียบร้อยแล้ว",
      deleteFailed: "ไม่สามารถลบแท็กได้",
      deleteConfirm: "คุณแน่ใจหรือไม่ที่จะลบแท็กนี้?",
      deleteConfirmWithUsage: "แท็กนี้ถูกใช้ใน {{count}} ความทรงจำ คุณแน่ใจหรือไม่ที่จะลบ?"
    },
    people: {
      name: "ชื่อ",
      usageCount: "จำนวนที่ใช้",
      memories: " ความทรงจำ",
      birthdate: "วันเกิด",
      deleted: "ลบบุคคลเรียบร้อยแล้ว",
      deleteFailed: "ไม่สามารถลบบุคคลได้",
      deleteConfirm: "คุณแน่ใจหรือไม่ที่จะลบบุคคลนี้?",
      deleteConfirmWithUsage: "บุคคลนี้ถูกแท็กใน {{count}} ความทรงจำ คุณแน่ใจหรือไม่ที่จะลบ?"
    }
  }
} as const;